(function () {
  if (window.customGATracker) return;

  const GA_CONFIG = window.customGAConfig || {};

  if (GA_CONFIG.enabled !== true) return;

  const G_ID = GA_CONFIG.gId || 'G-KPM1Z68SKV';
  const PAGE_TYPE = GA_CONFIG.pageType || '';
  const STORAGE_PREFIX = 'lt_';
  const HOVER_DWELL_THRESHOLD = 100;
  // 指针从按下到松开的位移超过此值（px）即判定为拖拽，本次 click 不计为点击，
  // 用于过滤轮播/拖拽组件在拖动结束时浏览器补发的“伪点击”。
  const CLICK_DRAG_THRESHOLD = 10;
  const GTAG_QUEUE_MAX = 200;
  const GTAG_POLL_INTERVAL = 200;
  const GTAG_POLL_TIMEOUT = 30000;

  const safeStorage = {
    get(key) {
      try {
        return localStorage.getItem(STORAGE_PREFIX + key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(STORAGE_PREFIX + key, value);
        return true;
      } catch {
        return false;
      }
    },
  };

  function safeParse(str) {
    try {
      return JSON.parse(str || '{}');
    } catch {
      return {};
    }
  }

  function generateAnonymousId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return `device_${crypto.randomUUID()}`;
    }
    const rand = Math.random().toString(36).slice(2, 10);
    return `device_${Date.now().toString(36)}_${rand}`;
  }

  function initAnonymousId() {
    let id = safeStorage.get('anonymous_id');
    if (!id) {
      id = generateAnonymousId();
      safeStorage.set('anonymous_id', id);
    }
    return id;
  }

  function initUserId() {
    try {
      const userInfo = localStorage.getItem('ltUserInfo');
      if (!userInfo) return;
      const user = JSON.parse(userInfo);
      if (user && user.uid) {
        window.customGATrackerUserId = user.uid;
      }
    } catch (error) {
      console.warn('userInfo 解析失败：', error);
    }
  }

  class CustomGATracker {
    constructor() {
      this.G_ID = G_ID;
      this.pageType = PAGE_TYPE;
      this.anonymousId = initAnonymousId();

      this._viewedElements = new WeakSet();
      this._hoverTimers = new WeakMap();
      this._eventQueue = [];
      this._gtagReady = false;

      this._waitForGtag();
      this._whenDomReady(() => {
        this._initViewTracking();
        this._initClickTracking();
        this._initHoverTracking();
      });
    }

    // ============ 内部：环境就绪 ============
    _whenDomReady(cb) {
      if (document.body) {
        cb();
        return;
      }
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    }

    _waitForGtag() {
      if (typeof window.gtag === 'function') {
        this._gtagReady = true;
        return;
      }
      const start = Date.now();
      const check = () => {
        if (typeof window.gtag === 'function') {
          this._gtagReady = true;
          this._flushQueue();
          return;
        }
        if (Date.now() - start > GTAG_POLL_TIMEOUT) {
          console.warn('gtag not ready in 30s, discarded cached events');
          this._eventQueue.length = 0;
          return;
        }
        setTimeout(check, GTAG_POLL_INTERVAL);
      };
      setTimeout(check, GTAG_POLL_INTERVAL);
    }

    _flushQueue() {
      while (this._eventQueue.length) {
        const { name, data } = this._eventQueue.shift();
        this._dispatch(name, data);
      }
    }

    _dispatch(name, data) {
      try {
        // 测试代码[开始]
        // const dataLines = Object.entries(data)
        //   .map(([key, value]) => `            ${key}: ${JSON.stringify(value)},`)
        //   .join('\n');
        // console.log('----------------上报事件[开始]----------------');
        // console.log(
        //   name,
        //   `
        //   window.gtag('event', '${name}', {
        //     send_to: '${this.G_ID}',
        //     source_page: '${document.referrer || ''}',
        //     current_page: '${location.href}',${dataLines ? `\n${dataLines}` : ''}
        //   });
        // `,
        // );
        // console.log('----------------上报事件[结束]----------------');
        // 测试代码[结束]
        window.gtag('event', name, {
          send_to: this.G_ID,
          source_page: document.referrer || '',
          current_page: location.href,
          page_type: this.pageType,
          ...data,
        });
      } catch (err) {
        console.warn('gtag dispatch failed:', err);
      }
    }

    _sendEvent(name, data) {
      if (this._gtagReady) {
        this._dispatch(name, data);
        return;
      }
      if (this._eventQueue.length >= GTAG_QUEUE_MAX) {
        this._eventQueue.shift();
      }
      this._eventQueue.push({ name, data });
    }

    // ============ 用户身份（公共 API） ============
    setUserId(uid) {
      if (uid == null) {
        window.customGATrackerUserId = '';
      } else {
        window.customGATrackerUserId = String(uid);
      }
    }

    getUserId() {
      return window.customGATrackerUserId || '';
    }

    // ============ 事件上报（公共 API） ============
    trackEvent(eventName, eventParams = {}) {
      if (!eventName) {
        console.warn('eventName is required');
        return;
      }
      const data = {
        anonymous_id: this.anonymousId,
        custom_user_id: this.getUserId(),
        ...eventParams,
      };
      this._sendEvent(eventName, data);
    }

    // ============ 内部：声明式事件 ============
    // 沿元素自身向祖先逐级收集 data-ga-context，越靠近自身越优先（深层覆盖浅层）
    _collectAncestorContext(el) {
      const list = [];
      let current = el;
      while (current && current.nodeType === 1) {
        const raw = current.dataset && current.dataset.gaContext;
        if (raw) list.unshift(safeParse(raw));
        if (current === document.body) break;
        current = current.parentElement;
      }
      if (list.length === 0) return {};
      return Object.assign({}, ...list);
    }

    _handleDeclarativeEvent(el, type, extras) {
      // 单事件 + 参数区分方案：data-ga-click / -view / -hover 的值不再是事件名，
      // 而是“交互点标识”（element）。事件名按触发类型固定为 lt_click / lt_view / lt_hover，
      // 具体是页面哪个位置的哪个交互，由 element 及其它通用参数区分。
      const element =
        type === 'click'
          ? el.dataset.gaClick
          : type === 'view'
          ? el.dataset.gaView
          : type === 'hover'
          ? el.dataset.gaHover
          : '';

      if (!element) return;

      const eventName = type === 'click' ? 'lt_click' : type === 'view' ? 'lt_view' : 'lt_hover';

      const localData = safeParse(el.dataset.gaData);
      const ancestorCtx = this._collectAncestorContext(el);

      const merged = {
        anonymous_id: this.anonymousId,
        custom_user_id: this.getUserId(),
        ...ancestorCtx,
        ...localData,
        ...(extras || {}),
        element,
        trigger_type: type,
      };

      this._sendEvent(eventName, merged);
    }

    // ============ 曝光跟踪 ============
    _initViewTracking() {
      if (!('IntersectionObserver' in window)) return;

      this._viewObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            // 声明 data-ga-view-repeat 的元素：每次从不可见进入视口都上报，
            // 既不取消观察也不做去重（适用于下拉/弹层等重复显隐的元素）。
            if (el.hasAttribute('data-ga-view-repeat')) {
              this._handleDeclarativeEvent(el, 'view');
              return;
            }
            this._viewObserver.unobserve(el);
            if (this._viewedElements.has(el)) return;
            this._viewedElements.add(el);
            this._handleDeclarativeEvent(el, 'view');
          });
        },
        {
          threshold: 0,
          rootMargin: '-10% 0px',
        }
      );

      document.querySelectorAll('[data-ga-view]').forEach((el) => {
        this._viewObserver.observe(el);
      });

      this._viewMutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            if (node.matches && node.matches('[data-ga-view]')) {
              if (!this._viewedElements.has(node)) {
                this._viewObserver.observe(node);
              }
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('[data-ga-view]').forEach((el) => {
                if (!this._viewedElements.has(el)) {
                  this._viewObserver.observe(el);
                }
              });
            }
          });
        });
      });
      this._viewMutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    // ============ 点击跟踪 ============
    _initClickTracking() {
      // 记录按下时的指针坐标，用于在 click 时判断这是否是一次拖拽。
      // 只监听 pointerdown（低频），不监听 pointermove（高频），开销极小。
      this._pointerDownX = 0;
      this._pointerDownY = 0;
      document.addEventListener(
        'pointerdown',
        (e) => {
          this._pointerDownX = e.clientX;
          this._pointerDownY = e.clientY;
        },
        true
      );

      document.addEventListener(
        'click',
        (e) => {
          const target = e.target;
          if (!(target instanceof Element)) return;
          // click 的坐标是松开时的位置，与按下位置相距过大说明发生了拖拽，
          // 此时这次 click 多为拖拽结束后浏览器补发的“伪点击”，不计为点击事件。
          const movedDistance = Math.hypot(e.clientX - this._pointerDownX, e.clientY - this._pointerDownY);
          if (movedDistance > CLICK_DRAG_THRESHOLD) return;
          const el = target.closest('[data-ga-click]');
          if (!el) return;
          this._handleDeclarativeEvent(el, 'click');
        },
        true
      );
    }

    // ============ 悬停跟踪 ============
    _initHoverTracking() {
      document.addEventListener('mouseover', (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const el = target.closest('[data-ga-hover]');
        if (!el) return;
        // 鼠标从该 hover 元素内部子节点移动而来 -> 不算重新进入
        if (e.relatedTarget instanceof Node && el.contains(e.relatedTarget)) return;
        this._hoverTimers.set(el, Date.now());
      });

      document.addEventListener('mouseout', (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const el = target.closest('[data-ga-hover]');
        if (!el) return;
        // 鼠标只是移到该 hover 元素内部其他子节点 -> 不算离开
        if (e.relatedTarget instanceof Node && el.contains(e.relatedTarget)) return;

        const enterTime = this._hoverTimers.get(el);
        if (!enterTime) return;
        this._hoverTimers.delete(el);

        const dwellTime = Date.now() - enterTime;
        if (dwellTime < HOVER_DWELL_THRESHOLD) return;

        this._handleDeclarativeEvent(el, 'hover', { dwell_time: dwellTime });
      });
    }

    // ============ 清理 ============
    dispose() {
      this._viewObserver && this._viewObserver.disconnect();
      this._viewMutationObserver && this._viewMutationObserver.disconnect();
    }
  }

  // 先初始化 userId，再实例化 tracker，避免最早一批事件丢失 custom_user_id
  initUserId();
  window.customGATracker = new CustomGATracker();
})();

// ===========================================================================
// Custom GA Tracker - 使用示例
// ===========================================================================
//
// 约定：下方所有示例中假设
//   anonymous_id = "device_xxx"   // 首次访问生成并持久化在 localStorage
//   custom_user_id      = "u_123"        // 登录后通过 setUserId() 或 ltUserInfo 注入
//   G_ID         = "G-KPM1Z68SKV"
//   page_type    = "product"      // 由 window.customGAConfig.pageType 自动注入（= Shopify request.page_type）
// 每次上报最终都会执行一次 gtag("event", <name>, <params>)。
//
// ===========================================================================
// 【单事件 + 参数区分方案】
// ---------------------------------------------------------------------------
// 同类型交互不再各自命名事件，而是收敛成 3 个固定事件，靠通用参数区分位置/对象：
//   - 点击  -> 事件名固定 "lt_click"
//   - 曝光  -> 事件名固定 "lt_view"
//   - 悬停  -> 事件名固定 "lt_hover"
//
// 关键变化：data-ga-click / data-ga-view / data-ga-hover 的“值”不再是事件名，
// 而是“交互点标识”（element）。tracker 会自动把它作为 element 参数上报。
//
// 通用参数规范（GA 后台只需为这一套字段建自定义维度即可覆盖全站）：
//   自动注入：trigger_type / page_type / anonymous_id / custom_user_id / source_page / current_page
//   页面主体：page_id（当前页主体 id，如系列页=collection_id、PDP=product_id）
//             page_name（当前页主体名称）
//   区块：    module（区块标识，kebab，如 home-swiper-v2）/ section_id（区块实例 id，排查用）
//   交互点：  element（触点标识）/ position（列表序号）
//   交互对象：content_type（product/collection/nav/menu/slide/scene/story/event/tab…）
//             content_id / content_name / content_url / variant_id
//             group_name（上级归类，如下拉项所属顶级导航、CTA 所属 Tab）
//   补充：    dwell_time / quantity / discount_code
//
// 字段语义铁律：
//   page_*    = “当前在哪个页面主体上”
//   content_* = “这次交互操作的那个对象”
//   element   = “点/曝光的是哪个触点”，module + element + trigger_type 可无损还原旧事件名
//   group_name= content_* 的父级分组（仅有层级时使用）
//
// 注：PC / 移动端的“同功能”触点（如导航）使用同一 element，端的区分交给 GA 自带
//     的“设备类别”维度，无需再拆 element 或额外字段。
// ---------------------------------------------------------------------------
// 一、声明式埋点（推荐，业务无需写 JS）
//
//   1) 基础点击（element = "cta"）
//      HTML:
//        <button data-ga-click="cta">立即购买</button>
//      用户点击后最终上报：
//        gtag("event", "lt_click", {
//          send_to: "G-KPM1Z68SKV",
//          page_type: "product",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          element: "cta",
//          trigger_type: "click",
//        });
//
//   2) 基础曝光（element 用 "section" 表示整块曝光）
//      HTML:
//        <div data-ga-view="section">活动 Banner</div>
//      被看到时最终上报：
//        gtag("event", "lt_view", {
//          send_to: "G-KPM1Z68SKV",
//          page_type: "home",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          element: "section",
//          trigger_type: "view",
//        });
//
//   3) 基础悬停（鼠标停留 >= 100ms 才上报，自动带 dwell_time）
//      HTML:
//        <div data-ga-hover="product_card">商品卡片</div>
//      鼠标离开时最终上报（假设停留 1234ms）：
//        gtag("event", "lt_hover", {
//          send_to: "G-KPM1Z68SKV",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          element: "product_card",
//          dwell_time: 1234,
//          trigger_type: "hover",
//        });
//
//   4) 区块根节点挂 context：module / page 主体（自动被后代继承）
//      HTML:
//        <main-product-v2
//          data-ga-context='{"module":"main-product-v2","section_id":"...","page_id":"9383749484824","page_name":"LiTime 12V 100Ah"}'
//          data-ga-view="section">
//          ...
//        </main-product-v2>
//      曝光时最终上报：
//        gtag("event", "lt_view", {
//          send_to: "G-KPM1Z68SKV",
//          page_type: "product",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          module: "main-product-v2",
//          section_id: "...",
//          page_id: "9383749484824",
//          page_name: "LiTime 12V 100Ah",
//          element: "section",
//          trigger_type: "view",
//        });
//
//   5) 列表里的交互对象用 content_* + position（data-ga-data 优先级最高）
//      HTML（产品推荐区块内某张卡片）:
//        <a
//          data-ga-click="product_card"
//          data-ga-data='{"content_type":"product","content_id":"9222242042136","variant_id":"48452567466264","content_name":"LiTime 12V 100Ah Connect","content_url":"/products/xxx","position":"1"}'>
//          ...
//        </a>
//      点击时最终上报（自动继承外层 module）：
//        gtag("event", "lt_click", {
//          send_to: "G-KPM1Z68SKV",
//          page_type: "home",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          module: "home-product-recommendation-v2",
//          element: "product_card",
//          content_type: "product",
//          content_id: "9222242042136",
//          variant_id: "48452567466264",
//          content_name: "LiTime 12V 100Ah Connect",
//          content_url: "/products/xxx",
//          position: "1",
//          trigger_type: "click",
//        });
//
//   6) 有层级的导航下拉项用 group_name 记录父级
//      HTML:
//        <menu-nav data-ga-context='{"module":"global-header-v2","group_name":"RV"}'>
//          ...
//          <a
//            data-ga-click="nav_dropdown_menu_item"
//            data-ga-data='{"content_type":"menu","content_name":"Storage","content_url":"/collections/12v-100ah"}'>
//            Storage
//          </a>
//        </menu-nav>
//      点击时最终上报：
//        gtag("event", "lt_click", {
//          send_to: "G-KPM1Z68SKV",
//          page_type: "index",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          module: "global-header-v2",
//          group_name: "RV",
//          element: "nav_dropdown_menu_item",
//          content_type: "menu",
//          content_name: "Storage",
//          content_url: "/collections/12v-100ah",
//          trigger_type: "click",
//        });
//
//   7) 同一元素同时挂多种事件（element 可不同）
//      HTML:
//        <div
//          data-ga-view="product_card"
//          data-ga-click="product_card"
//          data-ga-data='{"content_type":"product","content_id":"123"}'>
//          商品卡片
//        </div>
//      曝光时 element="product_card" + trigger_type="view"；
//      点击时 element="product_card" + trigger_type="click"。
//
//   合并优先级（从低到高）：
//     anonymous_id / custom_user_id / page_type
//       < 祖先链 data-ga-context（外层 -> 内层逐层覆盖）
//       < 元素自身 data-ga-data
//       < element / trigger_type（始终不可被业务覆盖）
//
// ---------------------------------------------------------------------------
// 二、命令式 / 自定义业务埋点（无法通过 DOM 表达的场景）
//
//   1) 普通业务事件
//      调用：
//        customGATracker.trackEvent("search_submit", {
//          keyword: "laptop",
//          result_count: 24,
//        });
//      最终上报：
//        gtag("event", "search_submit", {
//          send_to: "G-KPM1Z68SKV",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          keyword: "laptop",
//          result_count: 24,
//        });
//
//   2) 接口调用结果上报
//      调用：
//        try {
//          await api.pay(orderId);
//          customGATracker.trackEvent("order_pay_success", { order_id: orderId });
//        } catch (err) {
//          customGATracker.trackEvent("order_pay_fail", {
//            order_id: orderId,
//            error_code: err.code,
//            error_msg: err.message,
//          });
//        }
//      成功时上报（假设 orderId="O1001"）：
//        gtag("event", "order_pay_success", {
//          send_to: "G-KPM1Z68SKV",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          order_id: "O1001",
//        });
//      失败时上报：
//        gtag("event", "order_pay_fail", {
//          send_to: "G-KPM1Z68SKV",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          order_id: "O1001",
//          error_code: "BALANCE_INSUFFICIENT",
//          error_msg: "余额不足",
//        });
//
//   3) 登录成功后绑定 user_id（之后所有事件都会自动带上）
//      调用：
//        customGATracker.setUserId(user.uid);
//      内部仅写入 window.customGATrackerUserId，不会立即触发 gtag，
//      下一次任何事件上报时会自动带上 custom_user_id=<user.uid>。
//
//   4) 退出登录清空 custom_user_id
//      调用：
//        customGATracker.setUserId(null);
//      之后事件上报时 custom_user_id="".
//
//   5) SPA 路由切换时上报 PV
//      调用：
//        router.afterEach((to) => {
//          customGATracker.trackEvent("page_view", {
//            path: to.fullPath,
//            title: document.title,
//          });
//        });
//      最终上报（假设进入 /product/123）：
//        gtag("event", "page_view", {
//          send_to: "G-KPM1Z68SKV",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          path: "/product/123",
//          title: "商品详情 - LinkTime",
//        });
//
//   6) 业务计时
//      调用：
//        const t0 = performance.now();
//        doHeavyTask().finally(() => {
//          customGATracker.trackEvent("task_done", {
//            duration_ms: Math.round(performance.now() - t0),
//          });
//        });
//      最终上报（假设耗时 350ms）：
//        gtag("event", "task_done", {
//          send_to: "G-KPM1Z68SKV",
//          anonymous_id: "device_xxx",
//          custom_user_id: "u_123",
//          duration_ms: 350,
//        });
//
// ===========================================================================
